import { Icon, useModal } from '@frontendmentorio/design-system-v2';

import Modal from './Modal';

export default function Share({ solution }) {
  const modal = useModal();

  return (
    <>
      <button
        className="bg-white border border-neutral-200 flex font-secondary font-bold gap-2 italic items-center rounded-full tracking-wider transition-colors uppercase px-5 py-2 hover:bg-neutral-50"
        onClick={modal.open}
      >
        Share
        <Icon name="share-nodes" style="solid" />
      </button>

      <Modal
        emoji="🤩"
        modal={modal}
        solution={solution}
        subtitle="Show off your hard work"
        title="Share your solution"
      />
    </>
  );
}
